const CART_STORAGE_KEY = "babyShop";
const CHECKOUT_SELECTION_KEY = "babyShop_checkout";
const TOAST_EVENT_NAME = "shop-toast";
const CART_UPDATED_EVENT_NAME = "cart-updated";

const parseStoredCart = () => {
  try {
    const raw = window.localStorage.getItem(CART_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const getCartKey = (product) =>
  `${String(product.id ?? "")}::${product.title ?? ""}`;

const emitToast = (message) => {
  window.dispatchEvent(
    new CustomEvent(TOAST_EVENT_NAME, {
      detail: { message },
    }),
  );
};

const emitCartUpdated = (items) => {
  const count = (Array.isArray(items) ? items : []).reduce(
    (sum, item) => sum + (item.quantity || 1),
    0,
  );
  window.dispatchEvent(
    new CustomEvent(CART_UPDATED_EVENT_NAME, {
      detail: { count },
    }),
  );
};

export const getCartItems = () => {
  if (typeof window === "undefined") return [];
  return parseStoredCart();
};

export const setCartItems = (items) => {
  if (typeof window === "undefined") return;
  const safeItems = Array.isArray(items) ? items : [];
  window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(safeItems));
  emitCartUpdated(safeItems);
};

export const showToast = (message) => {
  if (typeof window === "undefined") return;
  if (!message) return;
  emitToast(message);
};

export const addProductToCart = (product, quantity = 1) => {
  if (typeof window === "undefined" || !product) return;
  const safeQuantity = Math.max(1, Number(quantity) || 1);

  const currentCart = parseStoredCart();
  const productId = getCartKey(product);
  const existingIndex = currentCart.findIndex(
    (item) => (item.cartKey || getCartKey(item)) === productId,
  );

  if (existingIndex > -1) {
    currentCart[existingIndex] = {
      ...currentCart[existingIndex],
      quantity: (currentCart[existingIndex].quantity || 1) + safeQuantity,
    };
  } else {
    currentCart.push({
      cartKey: productId,
      id: product.id,
      title: product.title,
      image: product.image,
      price: product.price,
      discountPrice: product.discountPrice,
      freeDelivery: Boolean(product.freeDelivery),
      quantity: safeQuantity,
      addedAt: new Date().toISOString(),
    });
  }

  window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(currentCart));
  emitCartUpdated(currentCart);
  emitToast(`${product.title} added to cart`);
};

export const getToastEventName = () => TOAST_EVENT_NAME;
export const getCartUpdatedEventName = () => CART_UPDATED_EVENT_NAME;
// export const getCartCount = () =>
//   getCartItems().reduce((sum, item) => sum + (item.quantity || 1), 0);
export const getCartCount = () => {
  const items = getCartItems();
  return items.length; // counts unique items only
};

export const setCheckoutSelectedItems = (selectedIds) => {
  if (typeof window === "undefined") return;
  const safeIds = Array.isArray(selectedIds) ? selectedIds : [];
  window.localStorage.setItem(CHECKOUT_SELECTION_KEY, JSON.stringify(safeIds));
};

export const getCheckoutSelectedItems = () => {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(CHECKOUT_SELECTION_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const clearCheckoutSelectedItems = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(CHECKOUT_SELECTION_KEY);
};
